import classes from "./PieChartWithoutSectors.module.css";
import useTheme from "../../../../common/hooks/useTheme";
import { PieChart, Pie, Cell } from "recharts";
import { getBiomarkerCategoryColor } from "../../store/helper";

type renderCustomizedLabelProps = {
  cx: number;
  cy: number;
  midAngle: number;
  outerRadius: number;
  label: string;
  percentage?: number;
  value?: number;
  valueKcal?: number;
  valueGrams?: number;
};

type Props = {
  title: string;
  pieData: {
    label: string;
    value: number;
    valueKcal?: number;
    categoryType: number;
    percentage?: number;
  }[];
  type: string;
};

const PieChartWithoutSectors = ({ title, pieData, type }: Props) => {
  const theme = useTheme();

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    outerRadius,
    label,
    percentage,
    value,
    valueKcal,
    valueGrams,
  }: renderCustomizedLabelProps) => {
    const radius = outerRadius + 20; // Adjust this value to position the labels further out
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    if (type === "nutrition") {
      return (
        <text
          x={x}
          y={y}
          fill={theme.colors_ds.NEUTRAL_TEXT_STRONG}
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          <tspan
            x={x}
            dy={type === "nutrition" ? "0em" : "-0.5em"}
            className={classes.pieChartLabelFirstLine}
          >
            {`${label} - ${percentage}%`}
          </tspan>

          <tspan x={x} dy={"1.2em"} className={classes.pieChartLabelSecondLine}>
            {type === "nutrition"
              ? `${valueKcal} kcal - ${valueGrams} gr`
              : `${value} kcal`}
          </tspan>
        </text>
      );
    } else {
      return (
        <text
          x={x}
          y={y}
          fill={theme.colors_ds.NEUTRAL_TEXT_STRONG}
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
          className={classes.pieChartLabelSecondLine}
        >
          {label}
        </text>
      );
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.title(theme)}>{title}</div>
      <div style={styles.pieChartContainer}>
        <PieChart
          width={type === "nutrition" ? 500 : 640}
          height={type === "nutrition" ? 350 : 360}
        >
          <Pie
            data={pieData}
            startAngle={90}
            endAngle={450}
            innerRadius={110}
            outerRadius={130}
            paddingAngle={2}
            dataKey="value"
            stroke="transparent"
            label={renderCustomizedLabel}
            labelLine={false}
          >
            {pieData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={getBiomarkerCategoryColor(
                  entry.categoryType,
                  theme,
                  type
                )}
              />
            ))}
          </Pie>
        </PieChart>
      </div>
    </div>
  );
};

export default PieChartWithoutSectors;

const styles = {
  container: {},
  title: (theme: any) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    marginBottom: "16px",
  }),
  pieChartContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
    flex: 2,
  },
};
